import React, { useState, useEffect } from 'react';

const VehicleReturn = ({ onBack }) => {
  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    stanje_km: '',
    stanje_vozila: '',
    lokacija_vracanja: '',
    kartica_gorivo: 'Da',
    napomena: '',
    slika_ostecenja: null
  });
  const [submitting, setSubmitting] = useState(false);

  // Fetch available vehicles on component mount
  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('auth_token');
      const apiBase = process.env.REACT_APP_API_URL;
      const urlBase = apiBase ? `${apiBase}/api` : `/api`;
      const url = `${urlBase}/vehicles/return?t=${Date.now()}`;
      const response = await fetch(url, {
        cache: 'reload',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0',
          'If-None-Match': 'no-match-for-this',
          'If-Modified-Since': 'Mon, 01 Jan 1990 00:00:00 GMT'
        }
      });
      const data = await response.json();

      // API may return an array directly or an object with { success, vehicles }
      if (Array.isArray(data)) {
        setVehicles(data);
      } else if (data && data.success) {
        setVehicles(data.vehicles);
      } else {
        setError((data && data.error) || 'Greška pri dohvaćanju vozila');
      }
    } catch (err) {
      setError('Greška pri povezivanju s serverom');
    } finally {
      setLoading(false);
    }
  };

  const handleVehicleSelect = async (vehicleId) => {
    try {
      console.log('Selecting vehicle ID:', vehicleId);
      const token = localStorage.getItem('auth_token');
      const apiBase = process.env.REACT_APP_API_URL;
      const urlBase = apiBase ? `${apiBase}/api` : `/api`;
      const response = await fetch(`${urlBase}/vehicles/${vehicleId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      console.log('Vehicle details response:', data);

      if (data && (data.success === undefined || data.success === true)) {
        const vehicle = data.vehicle || data;
        console.log('Setting selected vehicle:', vehicle);
        setSelectedVehicle(vehicle);
        setFormData(prev => ({
          ...prev,
          stanje_km: vehicle.stanje_km || '',
          stanje_vozila: vehicle.ostecenje || '',
          napomena: vehicle.napomena || ''
        }));
        console.log('Form data updated with:', {
          stanje_km: vehicle.stanje_km || '',
          stanje_vozila: vehicle.ostecenje || '',
          napomena: vehicle.napomena || ''
        });
      } else {
        console.error('Error in vehicle details:', data.error);
        setError(data.error || 'Greška pri dohvaćanju detalja vozila');
      }
    } catch (err) {
      console.error('Error selecting vehicle:', err);
      setError('Greška pri povezivanju s serverom');
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        slika_ostecenja: file
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedVehicle) {
      setError('Molimo odaberite vozilo');
      return;
    }

    try {
      setSubmitting(true);
      setError('');
      setSuccess('');


      // Get authentication token
      const userData = localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : null;
      const token = localStorage.getItem('auth_token');

      // Use Python backend endpoint with FormData
      const formDataToSend = new FormData();
      formDataToSend.append('automobil_id', selectedVehicle.automobil_id);
      formDataToSend.append('stanje_km', formData.stanje_km);
      formDataToSend.append('stanje_vozila', formData.stanje_vozila);
      formDataToSend.append('lokacija_vracanja', formData.lokacija_vracanja);
      formDataToSend.append('napomena', formData.napomena || '');
      if (formData.slika_ostecenja) {
        formDataToSend.append('slika_ostecenja', formData.slika_ostecenja);
      }

      const apiBase = process.env.REACT_APP_API_URL;
      const urlBase = apiBase ? `${apiBase}/api` : `/api`;
      const response = await fetch(`${urlBase}/vehicles/return`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
          // Don't set Content-Type - let browser set it for FormData
        },
        body: formDataToSend
      });

      const data = await response.json();

      if (data.success) {
        setSuccess('Vraćanje vozila uspješno zabilježeno!');
        // Stay on this screen: clear selection and form, refresh list
        setSelectedVehicle(null);
        setFormData({
          stanje_km: '',
          stanje_vozila: '',
          lokacija_vracanja: '',
          kartica_gorivo: 'Da',
          napomena: '',
          slika_ostecenja: null
        });
        fetchVehicles();
        // Clear success message after 5 seconds
        setTimeout(() => setSuccess(''), 5000);
      } else {
        setError(data.error || 'Greška pri vraćanja');
      }
    } catch (err) {
      setError('Greška pri povezivanju s serverom');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #CAE0BC 0%, #EAFAEA 100%)',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{ color: '#6C8B58', fontSize: '1.2rem' }}>Učitavanje vozila...</div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #CAE0BC 0%, #EAFAEA 100%)',
      fontFamily: 'Arial, sans-serif',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        maxWidth: '800px',
        margin: '0 auto',
        overflow: 'hidden'
      }}>
        {/* Header */}
        <div style={{
          background: '#6C8B58',
          color: 'white',
          padding: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <h1 style={{ margin: 0, fontSize: '1.5rem' }}>Vraćanje vozila</h1>
          <button
            onClick={onBack}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '1rem'
            }}
          >
            ← Nazad
          </button>
        </div>

        <div style={{ padding: '30px' }}>
          {error && (
            <div style={{
              background: '#fee',
              color: '#c33',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '20px',
              border: '1px solid #fcc'
            }}>
              {error}
            </div>
          )}
          {success && (
            <div style={{
              background: '#d4edda',
              color: '#155724',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '20px',
              border: '1px solid #c3e6cb'
            }}>
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* Vehicle Selection */}
            <div style={{ marginBottom: '30px' }}>
              <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                Odaberite vozilo za vraćanje *
              </label>
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                gap: '15px',
                padding: '10px',
                border: '2px solid #e1e5e9',
                borderRadius: '8px',
                backgroundColor: '#f8f9fa'
              }}>
                {vehicles.map(vehicle => (
                  <div
                    key={vehicle.automobil_id}
                    onClick={() => handleVehicleSelect(vehicle.automobil_id)}
                    style={{
                      cursor: 'pointer',
                      border: selectedVehicle?.automobil_id === vehicle.automobil_id ? '3px solid #6C8B58' : '2px solid #e1e5e9',
                      borderRadius: '12px',
                      padding: '15px',
                      backgroundColor: selectedVehicle?.automobil_id === vehicle.automobil_id ? 'rgba(108, 139, 88, 0.1)' : 'white',
                      transition: 'all 0.3s ease',
                      textAlign: 'center'
                    }}
                    onMouseOver={(e) => {
                      if (selectedVehicle?.automobil_id !== vehicle.automobil_id) {
                        e.target.style.borderColor = '#6C8B58';
                        e.target.style.backgroundColor = 'rgba(108, 139, 88, 0.05)';
                      }
                    }}
                    onMouseOut={(e) => {
                      if (selectedVehicle?.automobil_id !== vehicle.automobil_id) {
                        e.target.style.borderColor = '#e1e5e9';
                        e.target.style.backgroundColor = 'white';
                      }
                    }}
                  >
                    <div style={{
                      width: '100%',
                      height: '120px',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      marginBottom: '10px',
                      backgroundColor: '#f0f0f0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      {vehicle.slika ? (
                        <img
                          src={`data:image/jpeg;base64,${vehicle.slika}`}
                          alt={`${vehicle.proizvodac} ${vehicle.model}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                          }}
                        />
                      ) : (
                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#666',
                          fontSize: '12px'
                        }}>
                          <div style={{ fontSize: '24px', marginBottom: '5px' }}>🚗</div>
                          <div>Nema slike</div>
                        </div>
                      )}
                    </div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333', marginBottom: '5px' }}>
                      {vehicle.proizvodac} {vehicle.model}
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      {vehicle.registracija}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {selectedVehicle && (
              <>
                {/* Vehicle Details */}
                <div style={{
                  background: '#f8f9fa',
                  padding: '20px',
                  borderRadius: '12px',
                  marginBottom: '30px'
                }}>
                  <h3 style={{ margin: '0 0 15px 0', color: '#333' }}>Detalji vozila</h3>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                    <div>
                      <strong>Proizvođač:</strong> {selectedVehicle.proizvodac}
                    </div>
                    <div>
                      <strong>Model:</strong> {selectedVehicle.model}
                    </div>
                    <div>
                      <strong>Registracija:</strong> {selectedVehicle.registracija}
                    </div>
                    <div>
                      <strong>Vrsta goriva:</strong> {selectedVehicle.vrsta_goriva}
                    </div>
                    <div>
                      <strong>Dodatna oprema:</strong> {selectedVehicle.dodatna_oprema || 'Nema'}
                    </div>
                    <div>
                      <strong>Napomena:</strong> {selectedVehicle.napomena || 'Nema'}
                    </div>
                  </div>
                </div>

                {/* Form Fields */}
                <div style={{ display: 'grid', gap: '20px' }}>
                  {/* Stanje km */}
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>
                      Stanje km *
                    </label>
                    <input
                      type="text"
                      value={formData.stanje_km}
                      onChange={(e) => handleInputChange('stanje_km', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid #e1e5e9',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        backgroundColor: '#f8f9fa'
                      }}
                      required
                    />
                  </div>

                  {/* Stanje vozila */}
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>
                      Oštećenje
                    </label>
                    <textarea
                      value={formData.stanje_vozila}
                      onChange={(e) => handleInputChange('stanje_vozila', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid #e1e5e9',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        backgroundColor: '#f8f9fa',
                        minHeight: '80px',
                        resize: 'vertical'
                      }}
                      placeholder="Opis stanja vozila..."
                    />
                  </div>

                  {/* Lokacija vraćanja */}
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>
                      Lokacija vraćanja *
                    </label>
                    <input
                      type="text"
                      value={formData.lokacija_vracanja}
                      onChange={(e) => handleInputChange('lokacija_vracanja', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid #e1e5e9',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        backgroundColor: '#f8f9fa'
                      }}
                      required
                    />
                  </div>

                  {/* Kartica za gorivo */}
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>
                      Prometna dozvola i kartica za gorivo
                    </label>
                    <select
                      value={formData.kartica_gorivo}
                      onChange={(e) => handleInputChange('kartica_gorivo', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid #e1e5e9',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        backgroundColor: '#f8f9fa'
                      }}
                    >
                      <option value="Da">Da</option>
                      <option value="Ne">Ne</option>
                    </select>
                  </div>

                  {/* Napomena */}
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>
                      Napomena
                    </label>
                    <textarea
                      value={formData.napomena}
                      onChange={(e) => handleInputChange('napomena', e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid #e1e5e9',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        backgroundColor: '#f8f9fa',
                        minHeight: '80px',
                        resize: 'vertical'
                      }}
                      placeholder="Dodatne napomene..."
                    />
                  </div>

                  {/* Slika oštećenja */}
                  <div>
                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>
                      Slika oštećenja
                    </label>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      style={{
                        width: '100%',
                        padding: '12px',
                        border: '2px solid #e1e5e9',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        backgroundColor: '#f8f9fa'
                      }}
                    />
                    {formData.slika_ostecenja && (
                      <p style={{ margin: '5px 0 0 0', fontSize: '0.9rem', color: '#666' }}>
                        Odabrana datoteka: {formData.slika_ostecenja.name}
                      </p>
                    )}
                  </div>
                </div>

                {/* Submit Button */}
                <div style={{ marginTop: '30px' }}>
                  <button
                    type="submit"
                    disabled={submitting}
                    style={{
                      width: '100%',
                      padding: '15px',
                      background: '#6C8B58',
                      color: 'white',
                      border: 'none',
                      borderRadius: '12px',
                      fontSize: '1.1rem',
                      fontWeight: 'bold',
                      cursor: submitting ? 'not-allowed' : 'pointer',
                      opacity: submitting ? 0.7 : 1
                    }}
                  >
                    {submitting ? 'Bilježenje...' : 'Zabilježi vraćanje'}
                  </button>
                </div>
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default VehicleReturn;
